var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-box-item"},[(_vm.image)?_c('ImageView',{staticClass:"image",attrs:{"src":_vm.image}}):_vm._e(),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }